import logo from "assets/logo.png";
import icon from "assets/icon.png";

import cover from "assets/cover.png";

const assets = {
  logo: logo,
  cover: cover,
  icon: icon,
};
export default assets;
